
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/combos/[slug]/[comboNumber]",
      function () {
        return require("private-next-pages/combos/[slug]/[comboNumber].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/combos/[slug]/[comboNumber]"])
      });
    }
  